export enum CardActionType {
  HideAccount = 'hideAccount',
  ConnectToBank = 'connectToBank',
  DownloadTransactions = 'downloadTransactions',
  RemoveConnection = 'removeConnection',
  UploadToAccount = 'uploadToAccount',
  EditAccount = 'editAccount',
  EditAccountName = 'editAccountName',
}
